import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

// ==========================================================
// Component แผ่นพิมพ์สติ๊กเกอร์ QR เปล่า สำหรับวัสดุสิ้นเปลือง (8 ดวง: 4x2)
// ใช้สำหรับพิมพ์สติ๊กเกอร์ CON- สำรองไว้ล่วงหน้า แล้วนำไปสแกนผูกกับสินค้าภายหลัง
// Layout: 200px x 400px (Rotated 90deg เป็น 400px x 200px ตาราง 4 คอลัมน์ x 2 แถว)
// ==========================================================
const BlankConsumableSheet = React.forwardRef(({ items = [], previewMode = false }, ref) => {
  // สร้าง array ให้ครบ 8 ช่อง
  const cells = items.slice(0, 8);

  return (
    <div
      ref={ref}
      style={{
        width: '200px',
        height: '400px',
        backgroundColor: '#ffffff',
        position: 'relative',
        overflow: 'hidden',
        border: previewMode ? '2px solid #cbd5e1' : 'none',
        boxSizing: 'border-box'
      }}
    >
      <div
        style={{
          width: '400px',
          height: '200px',
          position: 'absolute',
          top: 0,
          left: '200px',
          transformOrigin: '0 0',
          transform: 'rotate(90deg)',
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gridTemplateRows: 'repeat(2, 1fr)',
          boxSizing: 'border-box',
          padding: '6px 4px',
          gap: '4px',
          fontFamily: "'Sarabun', 'Segoe UI', -apple-system, sans-serif",
          color: '#000000'
        }}
      >
        {cells.map((item, idx) => {
          const code = item.qr_code || item.id || `CON-${idx + 1}`;
          return (
            <div
              key={item.id || idx}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                boxSizing: 'border-box',
                padding: '3px 2px',
                border: '1.5px dashed #000000',
                borderRadius: '4px',
                backgroundColor: '#ffffff'
              }}
            >
              {/* Mini Inverted Badge */}
              <div
                style={{
                  backgroundColor: '#000000',
                  color: '#ffffff',
                  fontSize: '8px',
                  fontWeight: 'bold',
                  padding: '1px 4px',
                  borderRadius: '2px',
                  lineHeight: 1.1,
                  marginBottom: '2px',
                  letterSpacing: '0.3px'
                }}
              >
                ■ CON ■
              </div>

              {/* QR Code */}
              <QRCodeCanvas
                value={code}
                size={54}
                level="M"
                style={{ width: '54px', height: '54px', display: 'block' }}
              />

              {/* Monospace UID */}
              <div
                style={{
                  fontSize: '7.5px',
                  marginTop: '2px',
                  fontFamily: 'monospace',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  letterSpacing: '-0.2px',
                  lineHeight: 1.1,
                  maxWidth: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {code}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default BlankConsumableSheet;
